import {Component, Input} from '@angular/core';
import {Section} from '../../model/resource-model';

@Component({
  selector: 'app-resource-section',
  templateUrl: './resource-section.component.html',
  styleUrls: ['./resource-section.component.css']
})
export class ResourceSectionComponent {
  @Input() section: Section;
}
